import { Dispatch } from 'redux';
import { filteredCarsFooter } from '../../constants';
import { Api } from '../Api';
import {
    FILTERED_CARS_FOOTER_ERROR,
    FILTERED_CARS_FOOTER_LOADING,
    FILTERED_CARS_FOOTER_SUCCESS
} from '../types/filteredCarsFooterTypes';

export const getFilteredCarsFooter = async (dispatch: Dispatch) => {
    dispatch({ type: FILTERED_CARS_FOOTER_LOADING });
    try {
        const resData = await Api.get(`/${filteredCarsFooter}`);
        if (resData.status) {
            dispatch({
                type: FILTERED_CARS_FOOTER_SUCCESS,
                payload: resData?.data?.models,
                msg: resData?.data?.msg,
                status: resData?.data?.status
            });
        }
    } catch (error) {
        dispatch({ type: FILTERED_CARS_FOOTER_ERROR, payload: error });
    }
};
